import { unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const AlertContainer = styled.div `
  padding: ${unit('xl')} 0;
`;
